import Styles from './Attribute.module.scss'
import React from 'react'
import { Input } from 'almanac-ui/TextInputField/Input'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { TagInput } from './TagInput'
import { useMobilePills } from 'blaze-ui/MobilePills/MobilePills'
import { Field } from 'components/Wizards/Field/Field'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { InformationCircleContained } from 'blaze-ui/icons'

type Props = {
  value: string
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined
  title: string
  name: string
  description?: string
  placeholder?: string
  doneOnEnter?: boolean
}

type PillsAttributeProps = {
  value: string[]
  onChange: (value: Set<string>) => void
  title: string
  name: string
  description?: string
  placeholder?: string
  isNative?: boolean
}

export const Attribute = ({ value, onChange, onBlur, title, description, name, doneOnEnter = false }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <div className={Styles.attribute}>
      <div className={Styles.heading}>
        <Heading level={4}>{title}</Heading>
        {description && !isSystemRedesignEnabled ? (
          <Text variant="metadata" color="var(--dark-60)" lineClamp={1}>
            {description}
          </Text>
        ) : null}
        {isSystemRedesignEnabled && description && (
          <Tooltip label={description}>
            <div style={{ cursor: 'pointer' }}>
              <InformationCircleContained size={15} color="var(--dark-15)" />
            </div>
          </Tooltip>
        )}
      </div>
      <div className={Styles.content}>
        <Input
          size="lg"
          isTextarea
          id={name}
          aria-label={name}
          name={name}
          value={value}
          className={Styles.textbox}
          onChange={onChange}
          onBlur={onBlur}
          doneOnEnter={doneOnEnter}
        />
      </div>
    </div>
  )
}

export const PillsAttribute = (props: PillsAttributeProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { value, title, description, placeholder, name, onChange, isNative = false } = props

  if (isNative) {
    return <NativePillsAttribute {...props} description={undefined} />
  }

  return (
    <div className={Styles.attribute}>
      <div className={Styles.heading}>
        <Heading level={4}>{title}</Heading>
        {description && !isSystemRedesignEnabled && (
          <Text variant="metadata" color="var(--dark-60)" lineClamp={1}>
            {description}
          </Text>
        )}
        {isSystemRedesignEnabled && description && (
          <Tooltip label={description}>
            <div style={{ cursor: 'pointer' }}>
              <InformationCircleContained size={15} color="var(--dark-15)" />
            </div>
          </Tooltip>
        )}
      </div>
      <div className={Styles.content}>
        <TagInput value={value} name={name} placeholder={placeholder || ''} onChange={onChange} />
      </div>
    </div>
  )
}

export const NativePillsAttribute = ({ value: values, title, description, onChange }: PillsAttributeProps) => {
  const { Pills, EditPillsButton } = useMobilePills({
    values,
    title,
    onUpdate: (values) => onChange(new Set(values)),
  })

  return (
    <Field label={title} description={description} headingLevel={3} rightContent={<EditPillsButton />}>
      <Pills />
    </Field>
  )
}
